export const CATEGORIES = ['设备', '试剂', '耗材', '服务'];

/** 种类对应的 Badge 颜色，用于区分展示 */
export const CATEGORY_BADGE_VARIANTS = {
	设备: 'primary',
	试剂: 'success',
	耗材: 'warning',
	服务: 'info',
	全部: 'secondary',
};

export const getCategoryBadgeVariant = (category) =>
	CATEGORY_BADGE_VARIANTS[category || '全部'] ?? 'secondary';

export const RULE_TYPES = [
	{ value: 'profitMarginRanges', label: '利润率' },
	{ value: 'percentage', label: '百分比' },
	{ value: 'fixed', label: '固定金额' },
];

/** 规则类型 Badge（SubtleBadge），随 data-bs-theme 切换 */
export const RULE_TYPE_BADGE_VARIANTS = {
	profitMarginRanges: 'warning',
	percentage: 'primary',
	fixed: 'info',
};

export const getRuleTypeBadgeVariant = (ruleType) => RULE_TYPE_BADGE_VARIANTS[ruleType] ?? 'secondary';

export const CALCULATION_BASES = [
	{ value: 'profit', label: '利润' },
	{ value: 'cost', label: '成本' },
	{ value: 'sellingPrice', label: '销售价' },
];

export const USER_GROUP_OPTIONS = [
	{ value: 'assistant', label: '销售助理' },
	{ value: 'sale', label: '普通销售' },
	{ value: 'coreSale', label: '核心销售' },
];
